export default __webpack_public_path__ + "static/ReactQuery-d72933988a7a8c7effc0b3badb32faa2.jpg";